import { render, staticRenderFns } from "./PrizeAddrsEdit.vue?vue&type=template&id=1c4ecc56&scoped=true&"
import script from "./PrizeAddrsEdit.vue?vue&type=script&lang=js&"
export * from "./PrizeAddrsEdit.vue?vue&type=script&lang=js&"
import style0 from "./PrizeAddrsEdit.vue?vue&type=style&index=0&id=1c4ecc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ecc56",
  null
  
)

export default component.exports